import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import DateRangePk from "./DateRangePk";

function Filters(props) {
  let [filtersJSON, changeFiltersState] = useState(
    JSON.stringify(props.filters || {})
  );
  let filters = JSON.parse(filtersJSON);

  if (!props.filters) return null;

  function toggleVariant(filterIndex, variantIndex) {
    let f = filters[filterIndex];

    if (f.activeVariants.indexOf(variantIndex) >= 0) {
      f.activeVariants.splice(f.activeVariants.indexOf(variantIndex), 1);
    } else {
      if (f.multiple) {
        f.activeVariants = [...f.activeVariants, variantIndex];
      } else {
        f.activeVariants = [variantIndex];
      }
    }
    f.active = f.activeVariants.length ? true : false;

    filters[filterIndex] = f;

    changeFiltersState(JSON.stringify(filters));
    returnResult();
  }

  function changeInputValue(filterIndex, value) {
    filters[filterIndex].value = value;
    changeFiltersState(JSON.stringify(filters));
  }

  function toggleFilterActive(filterIndex) {
    filters[filterIndex].active = !filters[filterIndex].active;
    changeFiltersState(JSON.stringify(filters));
  }

  function returnResult() {
    let result = [];
    if (filters) {
      filters.forEach((f) => {
        if (f.kind === "dropdown") {
          let thisResult = [];
          if (f.active) {
            f.variants.forEach((variant, index) => {
              if (f.activeVariants.includes(index) && variant[1]) {
                thisResult = thisResult.concat(variant[1]);
              }
            });
            if (f.activeVariants.length > 1) {
              thisResult.forEach((objSearch, index, thisResult) => {
                thisResult[index].condition = "OR";
              });
              thisResult[0].condition = "AND";
              thisResult[0].lstr = "(";
              thisResult[thisResult.length - 1].rstr = ")";
            }
            result = result.concat(thisResult);
          }
        }
        if (f.kind === "bitwise") {
          if (f.active) {
            let bitwiseValue = 0;
            f.variants.forEach((variant, index) => {
              if (f.activeVariants.includes(index) && variant[1]) {
                bitwiseValue = bitwiseValue | variant[1];
              }
            });
            result = result.concat([
              { field: f.id, compare: "AND", value: bitwiseValue },
            ]);
          }
        }
        if (f.kind === "input") {
          if (f.value) {
            result = result.concat([
              { field: f.id, compare: "EQL", value: f.value },
            ]);
          }
        }
        if (f.kind === "mask") {
          if (f.value) {
            result = result.concat([
              { field: f.id, compare: "IKE", value: `%${f.value}%` },
            ]);
          }
        }
        if (f.kind === "range") {
          if (f.value[0] && f.value[1]) {
            let startDate = new Date(f.value[0]);
            let endDate = new Date(f.value[1]);

            result = result.concat(
              [
                {
                  lstr: "(",
                  field: f.id,
                  compare: "GEQ",
                  value: f.timestamp
                    ? startDate.getTime()
                    : startDate.toLocaleDateString(),
                },
              ],
              [
                {
                  rstr: ")",
                  field: f.id,
                  compare: "LEQ",
                  value: f.timestamp
                    ? endDate.getTime()
                    : `${endDate.toLocaleDateString()} 23:59:59`,
                },
              ]
            );
          }
        }
      });
    }
    props.changeFn(result);
  }

  function renderFilter(filter, filterIndex) {
    //Dates range
    if (filter.kind === "range") {
      let startDate = new Date(filter.value[0]);
      let endDate = new Date(filter.value[1]);

      let label =
        filter.value[0] && filter.value[1] ? (
          <span className="ml-2">
            <span className="text-primary">
              {startDate.toLocaleDateString()} - {endDate.toLocaleDateString()}
            </span>
            <i
              className="flaticon2-cross icon-sm ml-2 mr-2 text-muted text-hover-danger"
              onClick={(e) => {
                e.stopPropagation();
                changeInputValue(filterIndex, "");
                returnResult();
              }}
            ></i>
          </span>
        ) : null;
      let picker = filter.active ? (
        <DateRangePk
          closeFn={() => {
            toggleFilterActive(filterIndex);
            returnResult();
          }}
          changeFn={(startDate, endDate) =>
            changeInputValue(filterIndex, [startDate, endDate])
          }
          show={filter.active ? true : false}
          startDate={filter.value[0]}
          endDate={filter.value[1]}
        />
      ) : null;

      return (
        <div key={filter.id} className="d-inline-block align-middle mr-2 my-2">
          <button
            className="btn btn-light"
            onClick={(e) => toggleFilterActive(filterIndex)}
          >
            {filter.title} {label}
            <i className="flaticon2-calendar-6 text-muted ml-2"></i>
          </button>
          {picker}
        </div>
      );
    }

    //Input box
    if (filter.kind === "input" || filter.kind === "mask") {
      let label = filter.value ? (
        <span className="ml-2">
          <span className="text-primary">{filter.value}</span>
          <i
            className="flaticon2-cross icon-sm ml-2 mr-2 text-muted text-hover-danger"
            onClick={(e) => {
              e.stopPropagation();
              changeInputValue(filterIndex, "");
              returnResult();
            }}
          ></i>
        </span>
      ) : null;
      return (
        <Dropdown
          key={filter.id}
          className="d-inline-block align-middle mr-2  my-2"
        >
          <Dropdown.Toggle variant="light">
            {filter.title}
            {label}
            <i className="fa fa-angle-down ml-3"></i>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <div className="p-3">
              <input
                type="text"
                value={filter.value}
                className="form-control"
                onChange={(e) => changeInputValue(filterIndex, e.target.value)}
                onBlur={() => returnResult()}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.target.blur();
                    document.dispatchEvent(new MouseEvent("click"));
                  }
                }}
              />
            </div>
          </Dropdown.Menu>
        </Dropdown>
      );
    }

    //Dropdown
    if (filter.kind === "dropdown") {
      let values = filter.variants.map((value, index) => {
        let [name] = value;
        return (
          <Dropdown.Item
            onClick={() => toggleVariant(filterIndex, index)}
            key={`${name}${index}`}
          >
            {filter.activeVariants.includes(index) ? (
              <i className="fa fa-check align-middle mr-2 text-primary"></i>
            ) : null}
            {name}
          </Dropdown.Item>
        );
      });

      let labelCaption = filter.activeVariants.length;
      if (filter.activeVariants.length === 1) {
        labelCaption = filter.variants[filter.activeVariants[0]][0];
      }

      let label =
        filter.activeVariants.length > 1 ? (
          <span className="label label-sm label-primary ml-2">
            {labelCaption}
          </span>
        ) : (
          <span className="text-primary ml-2"> {labelCaption}</span>
        );

      return (
        <Dropdown
          key={filter.id}
          className="d-inline-block align-middle mr-2  my-2"
        >
          <Dropdown.Toggle variant="light">
            {filter.title}
            {filter.active ? label : null}
            <i className="fa fa-angle-down ml-3"></i>
          </Dropdown.Toggle>

          <Dropdown.Menu>{values}</Dropdown.Menu>
        </Dropdown>
      );
    }

    //Bitwise
    if (filter.kind === "bitwise") {
      let values = filter.variants.map((value, index) => {
        let [name] = value;
        return (
          <Dropdown.Item
            onClick={() => toggleVariant(filterIndex, index)}
            key={name}
          >
            {filter.activeVariants.includes(index) ? (
              <i className="fa fa-check align-middle mr-2 text-primary"></i>
            ) : null}
            {name}
          </Dropdown.Item>
        );
      });

      let labelCaption = filter.activeVariants.length;
      if (filter.activeVariants.length === 1) {
        labelCaption = filter.variants[filter.activeVariants[0]][0];
      }

      let label =
        filter.activeVariants.length > 1 ? (
          <span className="label label-sm label-primary ml-2">
            {labelCaption}
          </span>
        ) : (
          <span className="text-primary ml-2"> {labelCaption}</span>
        );

      return (
        <Dropdown
          key={filter.id}
          className="d-inline-block align-middle mr-2  my-2"
        >
          <Dropdown.Toggle variant="light">
            {filter.title}
            {filter.active ? label : null}
            <i className="fa fa-angle-down ml-3"></i>
          </Dropdown.Toggle>

          <Dropdown.Menu>{values}</Dropdown.Menu>
        </Dropdown>
      );
    }
  }

  return (
    <div>
      {filters.map((filter, filterIndex) => renderFilter(filter, filterIndex))}
    </div>
  );
}
export default Filters;

/*
  props.filters - is an array of objects

  //Input field example
   {
      id: "userid",  == api field!
      title: "ID пользователя",
      kind: "input",
      value: "",
    },

  //Date range calendar example
     {
      id: "created", == api field!
      title: "Дата начала",
      kind: "range",
      active: false,
      value: [],
    },

  //Dropdown example
    {
      id: "state",  //Custom id (key)
      title: "По state", 
      active: false,
      activeVariants: [],
      multiple: false, //allow multiple
      kind: "dropdown",
      variants: [
        [
          "Locked", //Varian caption
          [{
              field: "state",  //Search expressions
              compare: "EQL",
              value: "6",
            },
            {
              field: "state",
              compare: "LEQ",
              value: "22",
            },
          ],
        ],
      ],
    },
*/
